import { Chip, ChipPropsVariantOverrides } from "@mui/material";

import { MediumCustomIcon } from "../../layer00";
import type { IconTypes } from "../../layer00/MediumCustomIcon/types";

export type BoZoneTrendDirection = "up" | "down" | "flat";

type BoZoneTrendPillProps = {
  direction: BoZoneTrendDirection;
  value: string;
};

export const direction2Chip: Record<
  BoZoneTrendDirection,
  {
    variant: keyof ChipPropsVariantOverrides;
    icon: IconTypes;
    stroke: string;
  }
> = {
  up: {
    variant: "success",
    icon: "TRENDUP",
    stroke: "#009F3F",
  },
  down: {
    variant: "warning",
    icon: "TENDDOWN",
    stroke: "#E67800",
  },
  flat: {
    variant: "info",
    icon: "HORIZONTALLINE",
    stroke: "#214294",
  },
};

export const BoZoneTrendPill = (props: BoZoneTrendPillProps) => {
  const chip = direction2Chip[props.direction];

  return (
    <Chip
      variant={chip.variant}
      label={props.value}
      icon={
        <MediumCustomIcon
          icon={chip.icon}
          stroke={chip.stroke}
          width={16}
          height={16}
        />
      }
    />
  );
};
